import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { env } from 'endpoints';

import app from './app-dux/app-dux.js';
import search from './app-dux/search-dux.js';
import hierarchy from './app-dux/hierarchy-dux.js';
import person from './app-dux/person-dux.js';
import superUsers from './app-dux/super-user-dux.js';
const AppStore = () => {
	/*******************************************************************************
	 *	Gather all the reducers
	 */
	const appReducer = combineReducers( {
		app,
		search,
		hierarchy,
		person,
		superUsers
	} );

	const rootReducer = ( state, action ) => {
		return appReducer( state, action );
	};

	/*******************************************************************************
	 *	Create Store
	 */
	const middleware = [ thunk ];

	if ( env ) {
		middleware.push( createLogger( {
			collapsed: true
		} ) );
	}

	return createStore(
		rootReducer,
		applyMiddleware( ...middleware )
	);
};

export default AppStore();
